import {AttrsSchema, Component, ConfigOptions} from 'panel';

import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {ButtonTheme} from 'common/components/button/constants';
import {getEntityType, promptSuperadminOverrideShare} from 'common/report/util/saved-entities';

import {validateSharingAttributes} from '../utils';
import {promptSharing} from '../index';
import {SharingButtonAttrs, SharingButtonState} from './types';
import {template} from './template';

export class SharingButton extends Component<SharingButtonState, SharingButtonAttrs> {
  static get attrsSchema(): AttrsSchema<SharingButtonAttrs> {
    return {
      ...super.attrsSchema,
      disabled: `boolean`,
      theme: {type: `string`, enum: Object.values(ButtonTheme), default: ButtonTheme.Secondary},
      type: `string`,
      id: `number`,
      'project-id': `number`,
      'display-override-confirmation': `boolean`,
    };
  }

  get config(): ConfigOptions<SharingButtonState> {
    return {
      template,
      defaultState: {
        modalOpen: false,
      },
      helpers: {
        handleClick: () => {
          this.openShareModal();
        },
        isDisabled: () =>
          this.attr(`disabled`) ||
          !validateSharingAttributes({
            projectId: this.attr(`project-id`),
            id: this.attr(`id`),
            type: this.attr(`type`),
          }) ||
          this.state.modalOpen,
      },
    };
  }

  private async openShareModal() {
    this.update({modalOpen: true});

    if (
      this.attr(`display-override-confirmation`) &&
      !(await promptSuperadminOverrideShare(getEntityType(this.attr(`type`))))
    ) {
      this.update({modalOpen: false});
      return;
    }

    await promptSharing({
      type: this.attr(`type`),
      id: this.attr(`id`),
      'project-id': this.attr(`project-id`),
    });
    this.update({modalOpen: false});
  }
}

export const SharingButtonEl = defineAndMakeJsxFactory(`mp-sharing-button`, SharingButton);
